export const convertToValidName = (name: string): string => {
	if (!name) {
		return '';
	}
	const sanitizedName = name.replace(/[$#@%^*]/gi, '');
	return encodeURIComponent(sanitizedName);
}
